// extracted by mini-css-extract-plugin
export default {"wrapper":"Section_wrapper__ygEtw","navWrapper":"Section_navWrapper__pn5Um"};